import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
import S_answerSetting from '@/service/api/v1/answerSetting';

export default {
  async index(answerSettingId, params) {
    const res = await base.index({
      parentName: 'answer_setting',
      parentId: answerSettingId,
      modelName: 'answer_setting_item',
      params,
    });
    return res;
  },
  async getOperators() {
    await S_answerSetting.updateNumConditionTypeListInVuex();
    const numConditionTypeList = store.state.model.numConditionTypeList;
    const customNum = numConditionTypeList.find(setting => setting.type === 'custom-num');
    return customNum.answer_setting_items;
  },
  async updateOperatorListInVuex(answerSettingId) {
    const operatorList = store.state.model.operatorList;
    if (!operatorList.length) {
      const newOperatorList = answerSettingId ? await this.index(answerSettingId) : await this.getOperators();
      store.dispatch('model/setOperatorList', newOperatorList);
    }
  }
}